import React from "react";

interface AvatarProps {
    avatarSrc: string | null;
    onClick: () => void;
    openHeader?: boolean;
    onTouchStart?: () => void;
}

export const Avatar: React.FC<AvatarProps> = ({ avatarSrc, onClick, onTouchStart }) => {
    let touchStartFired = false; // Флаг для отслеживания того, было ли уже срабатывание onTouchStart

    const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.preventDefault(); // Отменяем стандартное действие браузера при клике
        if (!touchStartFired) {
            onClick();
        }
        touchStartFired = false; // Сбрасываем флаг после клика
    };

    const handleTouchStart = (event: React.TouchEvent<HTMLDivElement>) => {
        event.preventDefault(); // Отменяем стандартное действие браузера при касании
        onTouchStart && onTouchStart(); // Проверяем, что onTouchStart определено, перед вызовом
        touchStartFired = true; // Устанавливаем флаг, что onTouchStart было срабатывание
    };

    return (
        <div
            className={`profile-avatar avatar light-gradient-bg`}
            onClick={handleClick}
            onTouchStart={handleTouchStart}
        >
            {avatarSrc && <img src={avatarSrc} alt="Аватар" />}
        </div>
    );
};
